import { log } from "../utils/logger";

interface ApiConfig {
  baseUrl: string;
  environment: string;
  enableLogging: boolean;
}

function getApiBaseUrl(): string {
  const envBaseUrl = import.meta.env.VITE_API_BASE_URL;
  if (envBaseUrl) {
    return envBaseUrl;
  }

  if (import.meta.env.PROD) {
    // For Railway deployment, assume backend is on same domain with /api prefix
    return window.location.origin;
  }

  return 'http://127.0.0.1:8000';
}

function getEnvironment(): string {
  return import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'development';
}

function isLoggingEnabled(): boolean {
  const envLogging = import.meta.env.VITE_ENABLE_API_LOGGING;
  if (envLogging !== undefined) {
    return envLogging === 'true';
  }

  return false;
}

export const apiConfig: ApiConfig = {
  baseUrl: getApiBaseUrl(),
  environment: getEnvironment(),
  enableLogging: isLoggingEnabled(),
};

export function buildApiUrl(endpoint: string): string {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

  // If baseUrl already includes /api, don't add it again
  if (apiConfig.baseUrl.includes('/api')) {
    return `${apiConfig.baseUrl}${cleanEndpoint}`;
  }

  return `${apiConfig.baseUrl}/api${cleanEndpoint}`;
}

if (apiConfig.enableLogging) {
  log.debug(
    "API configuration loaded",
    {
      baseUrl: apiConfig.baseUrl,
      environment: apiConfig.environment,
      loggingEnabled: apiConfig.enableLogging,
      productionMode: import.meta.env.PROD,
    },
    "api",
  );
}
